import connect from 'components/Shared/connect';
import { FilterValue } from 'models/FilterValue';
import { filterToggle } from 'components/Filter/actions';
import { filterChanged } from 'views/ProductlistPage/actions';
import { Checkbox as FormCheckbox } from 'components/Shared/Form/checkbox';
import styles from './checkbox.scss';
import { ColourBox } from 'components/Shared/ColourBox';
import { FilterValueWithChildren } from 'models/FilterValueWithChildren';
import cn from 'classnames';
import { ValueFacetFilter } from 'models/ValueFacetFilter';
import { Fragment } from 'react';

const hasChildren = (value: FilterValueWithChildren) =>
  value && value.subValues && !!value.subValues.length;

interface OnChangeProps {
  onChange: (
    filter: FilterValueWithChildren | FilterValue,
    parent?: FilterValueWithChildren
  ) => () => void;
}
interface MergedProps extends OwnProps, OnChangeProps {}
interface OwnProps extends ValueFacetFilter {
  className?: string;
}

interface CheckProps {
  hasColour: boolean;
  parent?: FilterValueWithChildren;
  value: FilterValue;
  onChange: (
    filter: FilterValueWithChildren | FilterValue,
    parent?: FilterValueWithChildren
  ) => () => void;
  className?: string;
}

const Check = ({ parent, value, onChange, hasColour, className }: CheckProps) => {
  return (
    <div
      onClick={onChange(value, parent)}
      onKeyPress={onChange(value, parent)}
      className={cn(styles.checkBoxContainer, className)}
    >
      <FormCheckbox
        checked={value.selected}
        readOnly
        className={styles.check}
        appearance="primary"
        color="charcoal"
      />
      {hasColour && <ColourBox className={styles.colorBox} colour={value.value} />}
      <p className={styles.label}>{value.displayName}</p>
      <p className={styles.amount}>({value.count})</p>
    </div>
  );
};

const _CheckBox = ({ values, onChange, name, className }: MergedProps) => {
  const hasColour = name.includes('bhcolour');
  const children = values.map((value: FilterValueWithChildren) => (
    <Fragment key={value.value}>
      <Check className={className} value={value} onChange={onChange} hasColour={hasColour} />
      {hasChildren(value) && (
        <div className={styles.subCheckbox}>
          {value.subValues.map(subValue => (
            <Check
              key={subValue.displayName}
              value={subValue}
              parent={value}
              onChange={onChange}
              hasColour={hasColour}
            />
          ))}
        </div>
      )}
    </Fragment>
  ));

  return <>{children}</>;
};

export const Checkbox = connect<MergedProps, OwnProps>(
  undefined,
  (dispatch, { name }: OwnProps) => ({
    onChange: (filter: FilterValue, parent?: FilterValueWithChildren) => () => {
      const action = { facet: name, filter, parent };
      dispatch(filterToggle(action));
      void dispatch(filterChanged(action));
    }
  })
)(_CheckBox);
